/**
 * @ngdoc directive
 * @name formcheckbox
 *
 * @description
 * Checkbox layout component
 */
module.directive('formSwitch', function () {
    'use strict';
    return {
        restrict: 'E',
        require: '^ngModel',
        replace: true,
        transclude: true,
        scope: {
            model: '=ngModel',
            name: '@',
            isReadonly: '=?',
            isRequired: '=?'
        },
        link: function ($scope, element, attrs, ctrl) {
            // ngChange handler
            ctrl.$viewChangeListeners.push(function() {
                $scope.$eval(attrs.ngChange);
            });
            $scope.update = function (value) {
                ctrl.$setViewValue(value);
            }
        },
        template:
                '<label class="aqua-form--switch grid grid-center grid-middle" ng-class="{\'is-active\': model}">' +
                '  <span class="aqua-form--switch--input">' +
                '    <input type="checkbox" name="{{name}}" ng-model="model" class="aqua-form--switch--input--box" ng-required="isRequired" ng-change="update(model)" ng-readonly="isReadonly">' +
                '  </span>' +
                '  <span class="aqua-form--switch-label" ng-transclude></span>' +
                '</label>'
    };
});
